import React from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Mic2, BookOpen } from 'lucide-react';
import { Card } from '../../components/ui/bootstrap';

function VoiceoversEmptyState() {
    const history = useHistory();
    const { org_id, id } = useParams();
    const { integration, isLoading } = useSelector(state => state.integration);

    const Shimmer = () => (
        <div className="d-flex flex-column gap-3">
            {_.range(4).map((index) => (
                <div
                    key={`vo-shimmer-${index}`}
                    className="shine rounded-4 p-4"
                    style={{ height: 72 }}
                />
            ))}
        </div>
    );

    if (isLoading) return <Shimmer />;

    return (
        <Card className="p-5 text-center" shadow>
            <div
                className="d-inline-flex align-items-center justify-content-center rounded-4 mb-4"
                style={{ width: 64, height: 64, background: 'rgba(var(--bs-primary-rgb),0.08)' }}
            >
                <Mic2 size={28} color="var(--bs-primary)" strokeWidth={1.5} />
            </div>

            <p className="fw-bold text-body-emphasis mb-2" style={{ fontSize: 18 }}>
                No voiceovers yet
            </p>
            <p className="mb-4" style={{ fontSize: 14 }}>
                Create your first AI voiceover audio to get started. Manage, edit and publish audio directly from here.
            </p>

            <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                {integration?.gates?.can_create_audio && (
                    <button
                        className="btn btn-primary"
                        style={{ fontSize: 13, padding: '8px 22px' }}
                        onClick={() => history.push(`/organisation/${org_id}/integration/${id}/content/new`)}
                    >
                        Create Audio
                    </button>
                )}
                <Link
                    target="_blank"
                    to={{ pathname: 'https://support.getlisten2it.com/portal/en/kb' }}
                    className="btn btn-sm d-inline-flex align-items-center gap-2"
                    style={{
                        background: 'rgba(var(--bs-primary-rgb),0.06)',
                        border: '1px solid rgba(var(--bs-primary-rgb),0.15)',
                        color: 'var(--bs-primary)',
                        borderRadius: 50,
                        fontSize: 13,
                        padding: '8px 18px',
                    }}
                >
                    <BookOpen size={14} />
                    Learn to use Listen2It
                </Link>
            </div>
        </Card>
    );
}

export default VoiceoversEmptyState;
